import React from 'react';
import PropTypes from 'prop-types';
import { Radio, RadioGroup } from '@opendate-app/setlist';

import { DEADLINE_OPTIONS } from '../grantFiltersConfig';

const listStyle = {
  display: 'flex',
  flexDirection: 'column',
  gap: 'var(--setlist-spacing-md)',
  minWidth: 220,
  padding: 'var(--setlist-spacing-xs)',
};

const DeadlineFilterOptions = ({ values = [], onChange, close }) => {
  const pick = (value) => {
    onChange([value]);
    close();
  };

  return (
    <RadioGroup name="grant-deadline" value={values[0] ?? null} onChange={pick}>
      <div style={listStyle}>
        {DEADLINE_OPTIONS.map((option) => (
          <Radio key={option.value} size="sm" value={option.value} label={option.label} />
        ))}
      </div>
    </RadioGroup>
  );
};

DeadlineFilterOptions.propTypes = {
  values: PropTypes.arrayOf(PropTypes.string),
  onChange: PropTypes.func.isRequired,
  close: PropTypes.func.isRequired,
};

export default DeadlineFilterOptions;
